import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ServerConfigService {

    private CONFIG_SERVER_HOST: string = environment.host;
    private CONFIG_SERVER_PORT: number = environment.port;
    private CONFIG_SERVER_PREURL: string = environment.preUrl;

    constructor() {
    }

    getRestUrl(): string {
        let serverUrl = this.CONFIG_SERVER_HOST;

        if (this.CONFIG_SERVER_PORT != 0) {
            serverUrl = serverUrl += ':' + this.CONFIG_SERVER_PORT;
        }

        if (this.CONFIG_SERVER_PREURL !== '') {
            serverUrl = serverUrl += this.CONFIG_SERVER_PREURL;
        }

        return serverUrl;
    }
}
